import React from 'react';
import { Plus } from 'lucide-react';

interface AddNewButtonProps {
  onClick: () => void;
  variant?: 'primary' | 'secondary';
  label?: string;
  disabled?: boolean;
}

const AddNewButton: React.FC<AddNewButtonProps> = ({
  onClick,
  variant = 'primary',
  label = 'Add New',
  disabled = false,
}) => {
  const baseClasses =
    'inline-flex items-center justify-center h-10 gap-2 px-6 text-sm font-medium tracking-wide transition duration-300 rounded focus-visible:outline-none whitespace-nowrap cursor-pointer disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-300 disabled:shadow-none';

  const variantClasses = {
    primary:
      'bg-primary text-white hover:bg-opacity-90 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600',
    secondary:
      'border border-secondary text-priamry bg-white hover:bg-secondary hover:text-white dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white',
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]}`}
      disabled={disabled}
    >
      <span className="order-2">{label}</span>
      <span className="relative">
        <Plus
          className="w-5 h-5"
          aria-hidden="true"
          role="graphics-symbol"
          aria-label="Add Icon"
        />
      </span>
    </button>
  );
};

export default AddNewButton;
